import { Parent } from "./parent"

export class Axis extends Parent {
  constructor(type, options) {
    super()
    this.type = type
    this.data = []
    this.axisTick = {
      alignWithLabel: true
    }
    this.axisLine = {
      show: true,
      lineStyle: {
        color: "rgba(255, 255, 255, 0.07)",
        type: "solid",
        width: 1
      }
    }
    this.axisLabel = {
      padding: [0, 0],
      interval: 0,
      show: true,
      color: "rgba(255,255,255,1)",
      fontFamily: "sans-serif",
      fontWeight: 400,
      fontSize: 14,
      rotate: 0,
      borderRadius: 0,
      margin: 20,
      backgroundColor: "rgba(255, 255, 0, 0)"
    }
    this.splitLine = {
      show: true,
      lineStyle: {
        color: "rgba(255, 255, 255, 0.07)",
        type: "solid",
        width: 1
      }
    }
    this.inverse = false
    this.name = ""
    this.nameLocation = "end"
    this.nameTextStyle = {
      color: "rgba(255,255,255,1)",

      fontWeight: 400,
      fontSize: 20,
      padding: [0, 0, 0, 0]
    }
    this.dataValueLengthControl = false //是否限制轴文字最大长度
    this.dataValueLength = 100 //轴文字最大长度
    this.show = true
    this.init(arguments)
  }
  init(args) {
    this.initData(args) //格式化data
    this.initAxisLabelRich() //格式化排序柱状图的rich
  }
  initAxisLabelRich() {
    if (this.axisLabel.rich && this.axisLabel.rich.rank) {
      Object.assign(
        this.axisLabel.rich,
        ...this.data.map((item, index) => {
          const res = {}
          //singleColor为true表示当前的轴排序文字的背景色为单独设置的，不会被默认背景色覆盖掉
          res[`rank${index}`] = { ...this.axisLabel.rich.rank, singleColor: false }
          return res
        })
      )
    }
  }

  initData(args) {
    const opt = args[1]
    this.forMateData()
    if (typeof opt === "object") {
      this.objDiff(this, opt)
    }
  }
  forMateData() {
    /**
     * 如果data为数组数字，则格式化为数组对象
     * 例：data:[{value:1},{value:2},{value:3}]
     */
    this.data.forEach((itemData, index) => {
      if (typeof itemData !== "object") {
        this.data[index] = { value: itemData }
      } else {
      }
    })
  }
}
